import React, { useEffect, useState } from 'react';
import BtnCircular from '../../../ds/BtnCircular/BtnCircular';
import './deliveryDrawer.scss';
import '../PickupLocationBox/pickupLocationBox.scss';
import PayedNusxa from '../PayedNusxa/PayedNusxa';
import ListItem from '../../../ds/ListItem/ListItem';
import TimeSlotBox from '../../organisms/TimeSlotBox/TimeSlotBox';
import BtnStandardIconText from '../../../ds/BtnStandardIconText/BtnStandardIconText';
import axios from 'axios';
import { useOrders } from '../../../hooks/orders';
import DeliveryOptions from '../DeliveryOptions/DeliveryOptions';
import Cookies from 'js-cookie';
import { useContent, useLanguages } from '../../../hooks/content';
import { Returntext } from '../../../pages/Landings/common/returnText';
import PaymentLoader from '../../../loaders/PaymentLoader';
import { useSnackbar } from 'notistack';
import { useTimeSlot } from '../../../hooks/ts';
import { ReactComponent as CloseIcon } from '../../../icons/x.svg';
import { ReactComponent as SuccessIcon } from '../../../icons/s-d.svg';
import { ReactComponent as HomeIcon } from '../../../icons/home.svg';
import { ReactComponent as WorkIcon } from '../../../icons/work.svg';
import { ReactComponent as TimeSlotIcon } from '../../../icons/ts-sc.svg';
import useMobileVhFix from '../../../hooks/height';
import WorkingHoursDisplay from '../WorkingHoursDisplay/WorkingHoursDisplay';
import { usePickupLocations } from '../../../hooks/pickupLocations';

const DeliveryDrawer = ({ cancelClick, activeOrder }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const { orders, refetchOrders } = useOrders(
    user.id,
    'RECEIVED_IN_TBILISI_WAREHOUSE',
  );

  const [dt, setDt] = useState('');
  const [isDistrict, setIsDistrict] = useState(false);
  const [atDoor, setAtDoor] = useState(false);
  const [ringBell, setRingBell] = useState(false);
  const { timeSlots } = useTimeSlot();

  const { enqueueSnackbar } = useSnackbar();

  const [ts, setTs] = useState('');
  const access_token = Cookies.get('access_token');

  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [dis, setDis] = useState(false);

  // New local state to track selected time slot
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(
    activeOrder.timeSlot,
  );

  const updatePaymentStatus = async () => {
    try {
      setDis(true);
      setLoading(true);

      const orderDate = timeSlots?.today?.includes(ts) ? 'today' : 'tomorrow';

      await axios.put(
        `${process.env.REACT_APP_API_URL}/orders/time-slot-update/${activeOrder.id}?accessToken=${access_token}`,
        {
          timeSlot: ts,
          day: orderDate,
          do_not_ring_bell: ringBell,
          leave_by_door: atDoor,
        },
      );

      // Update local state with the selected time slot
      setSelectedTimeSlot(ts);

      refetchOrders();
      enqueueSnackbar(
        Returntext(contentManagementData, 'ErrorMessages-time', lang),
        {
          variant: 'success',
        },
      );
    } catch (error) {
      refetchOrders();
      enqueueSnackbar(
        Returntext(contentManagementData, 'ErrorMessages-time2', lang),
        {
          variant: 'error', // Changed to 'error' for error messages
        },
      );
    } finally {
      setLoading(false);
      setDisabled(false);
      setDis(false);
    }
  };

  const { lang } = useLanguages();
  const { contentManagementData } = useContent();

  const airwayDate = activeOrder?.order_date;

  let month = '';
  let day = '';

  if (airwayDate) {
    const dateObject = new Date(airwayDate);
    month = dateObject.toLocaleString('default', { month: 'short' });
    day = dateObject.getDate();
  }

  useEffect(() => {
    const checkDistrict = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/district/find?lat=${activeOrder?.orderDetail?.lat}&lng=${activeOrder?.orderDetail?.lang}&accessToken=${access_token}`,
        );

        if (res?.data === false) {
          setIsDistrict(false);
        } else {
          setIsDistrict(true);
        }
      } catch (err) {
        console.log(err);
      }
    };

    const checkTime = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/district/date?accessToken=${access_token}`,
        );

        setDt(res.data);
      } catch (err) {
        console.log(err);
      }
    };

    checkTime();
    checkDistrict();
  }, [activeOrder, access_token]);

  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoader(false);
    }, 3500);

    return () => clearTimeout(timer);
  }, []);

  useMobileVhFix();

  // Was this order paid for as Office Pickup?  If so we skip the whole
  // time-slot flow and just render the chosen pickup location read-only —
  // customers aren't allowed to switch offices from here.
  const isPickup = activeOrder?.delivery_method === 'pickup';

  // Pickup has its own copy ("<key>_pickup" in content management); falls
  // back to the delivery text until those identifiers are filled in.
  const methodText = (key) =>
    (isPickup && Returntext(contentManagementData, `${key}_pickup`, lang)) ||
    Returntext(contentManagementData, key, lang);

  // Fetch the full pickup location (with working_hours) from the API so the
  // card always has complete data, regardless of what fields the order embeds.
  const { pickupLocations } = usePickupLocations();
  const pickupLocationId =
    activeOrder?.pickup_location?.id || activeOrder?.pickup_location_id;
  const pickup =
    pickupLocations.find((l) => l.id === pickupLocationId) ||
    activeOrder?.pickup_location;

  return (
    <div className="delivery-drawer">
      {loader && <PaymentLoader bg={true} />}
      <div className="shadow" onClick={cancelClick}></div>
      <div className="drawer-wrap">
        <div className="header">
          <div className="left"></div>

          <div className="middle">
            {Returntext(
              contentManagementData,
              'Delivery_settled_drawer_header 2',
              lang,
            )}
          </div>

          <BtnCircular
            size={'sm'}
            mainColor={'white'}
            svg={<CloseIcon />}
            disabled={false}
            mode={'active'}
            onClick={cancelClick}
          />
        </div>

        <div className="body-dl">
          {/* Success box — shown while nothing is settled yet OR for a pickup
              order (pickup orders are considered "settled at checkout"). */}
          {(!selectedTimeSlot || isPickup) && (
            <div className="success-box">
              <div className="mdt">
                <SuccessIcon className="st-icon" />
                <div className="mdt-main-txt">
                  {methodText('DMH')}
                </div>
              </div>
            </div>
          )}

          {/* ---------------- Office Pickup — read-only view ----------------
              Mirrors the .selected-details card that PickupLocationBox renders
              once a location has been chosen, but without any picker chrome —
              the customer cannot switch offices from here. */}
          {isPickup && (
            <div className="ts-details">
              <div className="txts">
                <div className="main">
                  {Returntext(contentManagementData, 'DRO', lang)}
                </div>
              </div>

              {/* Read-only pickup card. Inline styles are used because the
                  parent .ts-details forces align-items:center, which would
                  otherwise shrink the card down to text width. */}
              <div
                style={{
                  width: '100%',
                  background: '#fff',
                  border: '1px solid rgba(34, 197, 94, 0.4)',
                  borderRadius: '12px',
                  padding: '14px 16px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '6px',
                  boxSizing: 'border-box',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '8px',
                  }}
                >
                  <span
                    style={{
                      fontWeight: 600,
                      fontSize: 15,
                      color: '#212b36',
                    }}
                  >
                    {pickup?.alias || 'Pickup point'}
                  </span>
                </div>
                {pickup?.address && (
                  <div style={{ fontSize: 13, color: '#454f5b' }}>
                    {pickup.address}
                  </div>
                )}
                {pickup?.additional_info && (
                  <div style={{ fontSize: 12, color: '#637381' }}>
                    {pickup.additional_info}
                  </div>
                )}
                {Array.isArray(pickup?.working_hours) &&
                  pickup.working_hours.length > 0 && (
                    <WorkingHoursDisplay
                      workingHours={pickup.working_hours}
                      style={{ marginTop: '4px' }}
                    />
                  )}
              </div>
            </div>
          )}

          {/* ---------------- Standard Delivery — time-slot flow ---------------- */}
          {!isPickup && selectedTimeSlot === null && (
            <div className="ts-details">
              <div className="txts">
                <div className="main">
                  {Returntext(
                    contentManagementData,
                    'Delivery_settled_drawer_header',
                    lang,
                  )}
                </div>
              </div>

              {isDistrict && <TimeSlotBox ts={ts} setTs={setTs} />}
              {isDistrict && (
                <DeliveryOptions
                  atDoor={atDoor}
                  setAtDoor={setAtDoor}
                  ringBell={ringBell}
                  setRingBell={setRingBell}
                />
              )}

              <ListItem
                hasBorder={true}
                hasPadding={true}
                hasIcon={true}
                headline={
                  activeOrder?.orderDetail?.title !== ''
                    ? activeOrder?.orderDetail?.title
                    : activeOrder?.orderDetail?.tag
                }
                description={`${activeOrder?.orderDetail?.address}, ${activeOrder?.orderDetail?.city}`}
                icon={
                  activeOrder?.orderDetail?.tag === 'home' ? (
                    <HomeIcon />
                  ) : (
                    <WorkIcon />
                  )
                }
              />
            </div>
          )}
          {!isPickup && selectedTimeSlot !== null && (
            <div className="ts-details">
              <div className="txts">
                <div className="main">
                  {Returntext(contentManagementData, 'DRO', lang)}
                </div>
              </div>
              <ListItem
                hasBorder={true}
                hasPadding={true}
                hasIcon={true}
                headline={
                  activeOrder?.orderDetail?.title !== ''
                    ? activeOrder?.orderDetail?.title
                    : activeOrder?.orderDetail?.tag
                }
                description={`${activeOrder?.orderDetail?.address}, ${activeOrder?.orderDetail?.city}`}
                icon={
                  activeOrder?.orderDetail?.tag === 'home' ? (
                    <HomeIcon />
                  ) : (
                    <WorkIcon />
                  )
                }
              />

              <ListItem
                hasBorder={true}
                hasPadding={true}
                hasIcon={true}
                headline={Returntext(contentManagementData, 'date_time', lang)}
                description={`${
                  month &&
                  day &&
                  `${day} ${Returntext(contentManagementData, month, lang)}`
                }, ${selectedTimeSlot}`}
                icon={<TimeSlotIcon />}
              />
            </div>
          )}

          <PayedNusxa
            main={methodText('PNT')}
            activeOrder={orders.find((order) => order.id === activeOrder.id)}
            type={'delivery'}
          />
        </div>

        {/* Footer with the delivery-confirmation button only shown for
            standard-delivery orders that haven't picked a slot yet. Office
            Pickup orders never see this — nothing for the customer to submit. */}
        {!isPickup && selectedTimeSlot === null && isDistrict && (
          <div className="footer">
            <BtnStandardIconText
              mode=""
              txt={Returntext(contentManagementData, 'cancel', lang)}
              disabled={false}
              size={'md'}
              icon={false}
              mainColor={'white'}
              onClick={cancelClick}
            />

            <BtnStandardIconText
              mode=""
              txt={Returntext(contentManagementData, 'delivery_btn', lang)}
              disabled={ts && !dis ? false : true}
              size={'md'}
              icon={false}
              mainColor={'green'}
              onClick={updatePaymentStatus}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DeliveryDrawer;